export const BRAND_LOGO_URL =
  "https://imagedelivery.net/-LSpQIg39J0gXmiDBooAYw/e29fd94f-5226-4746-7aaf-5829236e7900/public";
